import { BasicTeamT } from "./TeamStatsHeader";
import styles from "./teamStats.module.scss";

interface TeamStatsRowProps {
  homeTeam: BasicTeamT;
  awayTeam: BasicTeamT;
  dataKey: keyof NonNullable<
    NonNullable<NonNullable<BasicTeamT>["teamStats"]>["efficiencyStats"]
  >;
  label: string;
}
export function TeamStatsRow({
  homeTeam,
  awayTeam,
  dataKey,
  label,
}: TeamStatsRowProps) {
  const awayTeamStats = awayTeam?.teamStats?.efficiencyStats;
  const homeTeamStats = homeTeam?.teamStats?.efficiencyStats;

  return (
    <div className={styles.row}>
      <div>{awayTeamStats?.[dataKey] ?? "-"}</div>
      <div className={styles.label}>{label}</div>
      <div>{homeTeamStats?.[dataKey] ?? "-"}</div>
    </div>
  );
}
